import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import GradientButton from '../../../../../../components/buttons/GradientButton';
import { formatCurrency } from '../../../../../../utils/helpers';
import { callApi } from '../../../../../../api/call';
import DeluxeHostedPaymentForm from '../../../../../../deluxe/components/DeluxeHostedPaymentForm';
import DeluxeBookingPaymentTabs from '../../../../../../deluxe/embedded/wallets/payment-method-tabs/DeluxeBookingPaymentTabs';

const DeluxeRemainingBalance = ({
  appointment,
  remainingBalance,
  onError,
  onSuccess,
  disabled
}) => {
  const [checkout, setCheckout] = useState(null);
  const [busy, setBusy] = useState(false);

  const handlePayBalance = async () => {
    try {
      setBusy(true);
      const companyId = localStorage.getItem('clientCompanyId');
      const clientId = appointment.clientId || localStorage.getItem('clientId') || null;
      const clientName = appointment.clientName || localStorage.getItem('clientName') || 'Guest';
      const clientEmail = appointment.clientEmail || localStorage.getItem('clientEmail') || '';
      const clientPhone = appointment.clientPhone || localStorage.getItem('clientPhone') || '';
      const { data } = await callApi(
        `/api/companies/${encodeURIComponent(companyId)}/payments/deluxe/checkout`,
        {
          companyId,
          appointment: {
            serviceId: appointment.serviceId,
            serviceName: appointment.serviceName,
            amount: remainingBalance,
            isDeposit: false,
            isBalancePayment: true,
            client: { id: clientId, name: clientName, email: clientEmail, phone: clientPhone },
            dateTimeISO: (appointment.dateTime && appointment.dateTime.toDate)
              ? appointment.dateTime.toDate().toISOString()
              : (new Date(appointment.dateTime)).toISOString(),
            employeeId: appointment.employeeId || appointment.employee?.id,
            employeeName: appointment.employeeName || appointment.employee?.name
          },
        }
      );
      setCheckout(data);
    } catch (err) {
      onError?.(err);
    } finally {
      setBusy(false);
    }
  };

  const finishCharge = async ({ cryptogram, paymentId }) => {
    try {
      setBusy(true);
      const companyId = localStorage.getItem('clientCompanyId');
      const { data } = await callApi(
        `/api/companies/${encodeURIComponent(companyId)}/payments/deluxe/charge`,
        {
          companyId,
          appointmentId: checkout.appointmentId,
          cryptogram,
          paymentId,
        }
      );
      onSuccess?.(data);
    } catch (err) {
      onError?.(err);
    } finally {
      setBusy(false);
    }
  };

  if (checkout) {
    return (
      <DeluxeBookingPaymentTabs
        wallets={checkout.wallets}
        disabled={busy || disabled}
        onWalletSuccess={({ paymentId }) => finishCharge({ paymentId })}
        onWalletError={onError}
        cardForm={(
          <DeluxeHostedPaymentForm
            hpfToken={checkout.hpfToken}
            scriptUrl={checkout.scriptUrl}
            mode="cryptogram"
            amount={remainingBalance}
            disabled={busy || disabled}
            onSuccess={({ cryptogram }) => finishCharge({ cryptogram })}
            onError={onError}
          />
        )}
      />
    );
  }

  return (
    <GradientButton
      variant="primary"
      onClick={handlePayBalance}
      disabled={disabled || busy}
      fullWidth
      size="large"
      sx={{ py: 1.5 }}
    >
      {disabled || busy ? (
        <CircularProgress size={24} />
      ) : (
        `Pay Remaining Balance (${formatCurrency(remainingBalance)})`
      )}
    </GradientButton>
  );
};

export default DeluxeRemainingBalance;
